module.exports = __webpack_public_path__ + "static/images/yzc.3535ac6.png";